import { useQuery } from '@gogame/query';

import { loadPromoCode } from 'scenes/Gallery/GalleryPage/Concepts/sources/fields';

import { promoCodes } from './queryKeyFactory';

export const usePromoCodeDetails = ({ id }, { enabled }) => {
  return useQuery(
    promoCodes({ id }),
    (_, { signal }) => loadPromoCode({ id }, { signal }),
    { enabled }
  );
};
